document.addEventListener("DOMContentLoaded", () => {
  if (!customElements.get("xmas-2025-showcase-bundle-card")) {
    class CommonProductShowcase extends HTMLElement {
      constructor() {
        super();
        // 初始化数据
        this.data = JSON.parse(this.getAttribute("products_with_variants"));

        // DOM 引用
        this.productSelector = $(this).find(".xmas-swiper-card-selector")[0];
        this.imageDom = $(this).find(".xmas-swiper-card-image img")[0];
        this.priceDom = $(this).find(".product-price-box")[0];
        this.cardDom = $(this).find("multi-add-cart-button")[0];
        this.buyNowDom = $(this).find(".showcase-buy-now")[0];
        this.productUrlDom = $(this).find(".xmas-swiper-card-product-url")[0];
        this.mobileSelector = $(this).find(".xmas-2025-swiper-selector-modal")[0];
        this.pcPopup = $(this).find("pc-selector-popup ")[0];
        this.idInput = $(this).find(".variant-id-input")[0];
        this.homeIdInput = $(this).find(".home_product_id")[0];
        this.titleInput = $(this).find(".home_product_title")[0];
        this.categoryInput = $(this).find(".home_product_category")[0];
      }

      connectedCallback() {
        this.initSelectProduct();
        this.updateData();
      }

      updateData(productHandle) {
        const product = productHandle ? this.data.find((i) => i.handle === productHandle) : this.data[0];

        if (!product) return;

        this.selectedProductHandle = product.handle;
        this.selectedVariantId = product.variantId;

        // 更新选择器 UI
        $(this.productSelector).find(".xmas-swiper-card-selector-text").text(product.title);

        // this.$globalOptions.find(".xmas-swiper-card-selector-option").each((_, e) => {
        //   $(e).toggleClass("selected", e.dataset.productHandle === this.selectedProductHandle);
        // });

        // 更新图片
        if (this.imageDom) {
          this.imageDom.src = product.imageUrl;
          this.imageDom.alt = product.imageAlt;
        }

        // 更新价格
        if (this.priceDom && product.price) {
          $(this.priceDom).find(".on-sale").text(theme.Currency.formatMoney(product.price, theme.strings.moneyFormat));
          if (product.compare_at_price) {
            $(this.priceDom)
              .find(".compare-at")
              .text(theme.Currency.formatMoney(product.compare_at_price, theme.strings.moneyFormat));
          }
        }

        if (this.productUrlDom) {
          this.productUrlDom.href = product.productUrl;
        }

        if (this.cardDom) {
          this.cardDom.setAttribute(
            "data-products",
            JSON.stringify([{ variantId: this.selectedVariantId, quantity: 1 }])
          );
        }

        if (this.buyNowDom) {
          this.buyNowDom.setAttribute("data-id", this.selectedVariantId);
        }

        if (this.idInput) {
          this.idInput.value = this.selectedVariantId;
        }

        if (this.homeIdInput) {
          this.homeIdInput.value = product.id;
        }
        if (this.titleInput) {
          this.titleInput.value = product.fullTitle||product.title;
        }
        if (this.categoryInput) {
          this.categoryInput.value = product.type;
        }
      }

      initSelectProduct() {
        this.initSelectProductCommon();

        if (this.data.length <= 1) {
          this.productSelector.classList.add("single-product");
          return;
        }
        if (window.innerWidth <= 850) {
          this.initSelectProductMobile();
        } else {
          this.initSelectProductPC();
        }
      }

      initSelectProductMobile() {
        if (!this.mobileSelector) return;
        const $selector = $(this.productSelector);
        $selector.on("click", () => {
          this.mobileSelector.open(this.selectedProductHandle);
        });
        this.mobileSelector.addEventListener("confirm", (e) => {
          this.updateData(e.detail.value);
        });
      }

      initSelectProductPC() {
        if (!this.productSelector) return;

        const $selector = $(this.productSelector);

        $selector.off("click.pcSelector").on("click.pcSelector", (e) => {
          e.stopPropagation();

          if (this.pcPopup.isShow) {
            this.pcPopup.close()
          } else {
            this.pcPopup.open({
              data: this.data,
              selectedValue: this.selectedProductHandle,
              anchorEl: this.productSelector,
            });
          }
          
        });

        this.pcPopup.addEventListener("confirm", (e) => {
          this.updateData(e.detail.value);
        });
      }

      initSelectProductCommon() {
        const swiperEl = this.productSelector?.closest(".swiper");
        if (!swiperEl) return;

        if (!swiperEl._optionsCloseBound) {
          swiperEl._optionsCloseBound = true;

          const waitSwiper = setInterval(() => {
            const instance = swiperEl.swiper;

            if (instance) {
              clearInterval(waitSwiper);

              // slide 切换时强制关闭 PC/Mobile 弹窗
              instance.on("slideChange", () => {
                $(document.body).find("pc-selector-popup ").each((index, el) => {
                  el.close()
                })
                if (this.mobileSelector) {
                  this.mobileSelector.close();
                }
              });

              // 左右 offset 逻辑（通用）
              const offset = getHorizontalOffset();
              instance.params.slidesOffsetBefore = offset;
              instance.params.slidesOffsetAfter = offset;

              if (instance.update) instance.update();
            }
          }, 50);
        }
      }
    }

    customElements.define("xmas-2025-showcase-bundle-card", CommonProductShowcase);
  }

  function getHorizontalOffset() {
    const vw = window.innerWidth;

    let wrapperWidth;

    if (vw >= 2560) {
      wrapperWidth = 1600; // fixed px
    } else if (vw >= 1500) {
      wrapperWidth = vw * 0.625; // 62.5vw
    } else if (vw >= 851) {
      wrapperWidth = vw * 0.8; // 80vw
    } else {
      wrapperWidth = vw * 0.92; // 92vw
    }

    const leftover = vw - wrapperWidth;
    return leftover / 2; // left offset = right offset
  }
});
